import { ReactElement } from 'react';
import { TickIcon, Spinner, TimerIcon, AttentionIcon, CancelledIcon } from '@weareopenr/component-library';
import { TPublicationStatus } from 'src/types/menu.types';
import styles from './StatusIcon.module.scss';

interface StatusIconProps {
  status: TPublicationStatus;
  animate?: boolean;
}

export const StatusIcon = ({ status, animate }: StatusIconProps): ReactElement | null => {
  const icons: Partial<Record<TPublicationStatus, ReactElement | null>> = {
    PENDING: animate ? (
      <Spinner className={styles.pending} />
    ) : (
      <TimerIcon size="medium" className={styles.scheduled} />
    ),
    PARTIAL_SUCCESS: <AttentionIcon size="medium" className={styles.scheduled} />,
    SUCCESS: <TickIcon size="medium" className={styles.success} />,
    SENT: <TickIcon size="medium" className={styles.success} />,
    CANCELLED: <CancelledIcon size="medium" className={styles.error} />,
    SCHEDULED: <TimerIcon size="medium" className={styles.success} />,
    FAILURE: <AttentionIcon size="medium" className={styles.error} />,
    REJECTED: <AttentionIcon size="medium" className={styles.error} />,
    PENDING_REVIEW: <TimerIcon size="medium" className={styles.scheduled} />,
    CAUTION: <AttentionIcon size="medium" className={styles.scheduled} />,
  };
  return icons[status] ?? null;
};
